import React from 'react';

const PlaceholderIcon = ({
  className = 'w-6 h-6',
  pathD = 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
}: {
  className?: string;
  pathD?: string;
}) => (
  // FIX: Corrected the xmlns attribute value
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={pathD} />
  </svg>
);

export default PlaceholderIcon;
